import { Link } from 'react-router-dom';
import { Shield, FileCheck, ClipboardCheck, Scale, BookOpen, Home } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard } from '@/components/animations';
import { motion } from 'framer-motion';
import { staggerContainer } from '@/components/animations';

const pillarLinks = [
  {
    to: '/elevadores',
    icon: Home,
    title: 'Elevadores em Portugal',
    desc: 'Guia sobre tipologias, normativa e mercado nacional',
  },
  {
    to: '/auditoria-elevadores',
    icon: Shield,
    title: 'Auditoria Tecnica',
    desc: 'Avaliacao independente do estado do elevador',
  },
  {
    to: '/seguranca-elevadores',
    icon: Scale,
    title: 'Seguranca de Elevadores',
    desc: 'Normas EN 81, riscos e prevencao de acidentes',
  },
  {
    to: '/inspecoes-periodicas-elevadores',
    icon: ClipboardCheck,
    title: 'Inspecoes Periodicas',
    desc: 'Obrigacoes legais e periodicidade em Portugal',
  },
  {
    to: '/contrato-manutencao-elevadores',
    icon: FileCheck,
    title: 'Contratos de Manutencao',
    desc: 'Clausulas criticas e avaliacao contratual',
  },
  {
    to: '/guia-elevador-residencial-portugal-2026',
    icon: BookOpen,
    title: 'Guia Elevador Residencial',
    desc: 'Guia completo para proprietarios em Portugal',
  },
];

export function SEOPillarLinks() {
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-5xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
              Recursos tecnicos sobre elevadores
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Conteudo tecnico independente para apoiar decisoes informadas sobre elevadores em Portugal.
            </p>
          </AnimatedItem>

          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {pillarLinks.map((link) => (
              <AnimatedItem key={link.to}>
                <Link to={link.to}>
                  <AnimatedCard className="p-5 rounded-xl bg-card border border-border hover:border-primary/40 transition-colors h-full">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                        <link.icon className="w-5 h-5 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground text-sm mb-1">{link.title}</h3>
                        <p className="text-xs text-muted-foreground">{link.desc}</p>
                      </div>
                    </div>
                  </AnimatedCard>
                </Link>
              </AnimatedItem>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
